import { Component, Input, Output, EventEmitter } from '@angular/core';
import { AppSettings } from '../../../app.settings';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'pagination',
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.scss']
})
export class PaginationFormComponent {
    public quantityPages: number[];
    public length = 0;
    public page = 1;
    private _firstNumber = 1;
    private _quantityItemsArray = 0;
    private _increment = 0;

    private _quantityItems = 0;
    @Input()
    set quantityItems(value: number) {
        this._quantityItems = value ? value : 0;
        this.pageSequenceGenerator();
    }

    private _quantityByPage = 0;
    @Input()
    set quantityByPage(value: number) {
        this._quantityByPage = value ? value : 0;
        this.pageSequenceGenerator();
    }
    @Input() quantityMaxPages = this.appSettings.settings.configs.defaultQuantityByPage;

    @Output() doSearchByPage = new EventEmitter();

    constructor(public appSettings: AppSettings) { }

    /**
     * Método responsável por calcular a quantidade de páginas que devem ser exibidas na paginação.
     */
    private pageSequenceGenerator() {
        this.length = Math.ceil((this._quantityItems / (this._quantityByPage ? this._quantityByPage : this.appSettings.settings.configs.defaultQuantityByPage)));
        this._quantityItemsArray = this.length > 0 && this.quantityMaxPages < this.length ? this.quantityMaxPages : this.length;
        this._increment = Math.trunc(this._quantityItemsArray / 2);
        this.quantityPages = Array.from(new Array(this._quantityItemsArray), (val, index) => index + this._firstNumber);
        this._firstNumber = 1;
    }

    /**
     * Método responsável por emitir o evento que vai realizar a busca de acordo com a página selecionada pelo usuário.
     * @param currentPage Número da página em que o usuário clicou.
     */
    public paginate(currentPage: number) {
        this.page = (this.page === this.length && currentPage === this.length) ? this.page : currentPage;
        this.doSearchByPage.emit(currentPage);
        this.calculateFirstNumberOfSequence(currentPage);
        this.pageSequenceGenerator();
    }

    /**
     * Método responsável por calcular o primeiro número da sequência de páginas exibidas.
     * @param currentPage Número da página em que o usuário clicou.
     */
    private calculateFirstNumberOfSequence(currentPage: number) {
        if (this.length > this._quantityItemsArray) {
            if ((currentPage + this._increment) > this.length) {
                this._firstNumber = (this.length - this.quantityMaxPages) + 1;
            } else {
                this._firstNumber = currentPage - this._increment;
            }

            if (this._firstNumber < 1) {
                this._firstNumber = 1;
            }
        }
    }

    /**
     * Método responsável por retornar o primeiro número da sequência de páginas.
     */
    getFirstNumberOfSequence(): number {
        return this.quantityPages[0];
    }

    /**
     * Método responsável por retornar o último número da sequência de páginas.
     */
    getLastNumberOfSequence(): number {
        return this.quantityPages[this.quantityPages.length - 1];
    }
}
